export enum Permission {
    USER_TAB = 101,
    ACCOUNTS_LIST = 102,
    RESOURCES = 103,
    OPERATORS = 104,
    ROLES = 105,
    THEMES = 106,
    EVENT_TRACKER = 107,
    ACCOUNT_GROUPS_LIST = 108,
    SYSTEM_USER_MANAGEMENT = 109,
    REFRESH_HOST_KEYS = 110,
    TELEPHONE_NUMBER_SETS = 111,
    CONNECTIONS_MANAGEMENT = 201,
    CREATE_ZOOM_CONNECTIONS = 202,
    HOST_MANAGEMENT = 203,
    ZOOM_WEBINAR_REPORT = 204,
    CREATE_AUTOSYNC_CONNECTION = 205,
    PREVIEW_KNOVIO_CONNECTION = 206,
    SYNC_SPEAKERS_TO_KNOVIO = 207,
    EDIT_MEETING_CONNECTIONS_WITH_TEMPLATE = 208,
    SEND_CONNECTIONS_EMAIL = 209,
    EDIT_KNOVIO_LIVE_STREAMS = 210,
    CREATE_AUDIO_BRIDGE_CONNECTION = 211,
    CREATE_CONNECTION_GROUPS = 212,
    EDIT_CONNECTION_GROUPS = 213,
    DELETE_CONNECTION_GROUPS = 214,
    ZOOM_MEETING_REPORTS = 215,
    VIEW_MEETING_LINKS = 216,
    MANAGE_MEETING_LINKS = 217,
    CREATE_NEW_EVENT = 301,
    EDIT_EVENT = 302,
    DELETE_EVENT = 303,
    VIEW_INTERNAL_EVENT_LINKS = 304,
    VIEW_ALL_EVENTS = 305,
    PLANNING_NOTES = 306,
    ACCESS_COMPLETED_EVENTS = 307,
    REPORTS_TAB = 308,
    UPLOAD_REPORT = 309,
    EDIT_REPORT = 310,
    DELETE_REPORT = 311,
    EVENT_INTERACTIONS_REPORT = 312,
    ATTENDEE_INTERACTIONS_REPORT = 313,
    EVENT_REGISTRATION_REPORT = 314,
    CREATE_EVENT_FROM_BLUEPRINT = 315,
    EDIT_EVENT_FROM_BLUEPRINT = 316,
    BOOK_AN_EVENT = 317,
    VIEW_SALESFORCE_ORDER = 318,
    PASSPORT_TAB = 401,
    TRIAGED_REGISTRATION = 402,
    VIEW_PASSPORT_LINK = 403,
    EDIT_EVENT_TITLE_AND_DESCRIPTION = 404,
    GENERATE_IMAGES_WITH_AI = 407,
    ATTENDEE_SSO = 408,
    SCHEDULE_TAB = 501,
    CREATE_NEW_MEETING = 502,
    UPDATE_MEETING = 503,
    DELETE_MEETING = 504,
    SCHEDULE_UPLOAD = 505,
    BULK_MEETING_STATUS_UPDATE = 506,
    SCHEDULE_DOWNLOAD = 507,
    GENERATE_REGISTRANTS_BY_SESSION = 508,
    CREATE_MEETING_FROM_TEMPLATE = 509,
    CREATE_MEETINGS_V2 = 510,
    CREATE_MEETING_WITH_AI = 511,
    RUN_MEETING = 601,
    VIEW_GUIDELINES = 602,
    MEETING_INTERACTIONS_REPORT = 604,
    MEETING_REGISTRATION_REPORT = 605,
    CREATE_ATTENDEE = 701,
    UPDATE_ATTENDEE = 702,
    DELETE_ATTENDEE = 703,
    CREATE_ORGANIZATION = 704,
    UPDATE_ORGANIZATION = 705,
    DELETE_ORGANIZATION = 706,
    ATTENDEE_UPLOAD = 707,
    ATTENDEE_DOWNLOAD = 708,
    PRESENTER_LINK_DOWNLOAD = 709,
    MANAGE_ATTENDEE_ROLODEX_MAPPING = 710,
    CREATE_NEW_ACCOUNT = 803,
    EDIT_ACCOUNT = 804,
    DELETE_ACCOUNT = 805,
    ACCESS_CODES_MANAGEMENT = 806,
    CREATE_ACCOUNT_GROUP_LIST = 807,
    EDIT_ACCOUNT_GROUP_LIST = 808,
    DELETE_ACCOUNT_GROUP_LIST = 809,
    MANAGE_SSO_CONFIGURATIONS = 810,
    CREATE_ROOM = 901,
    EDIT_ROOM = 902,
    DELETE_ROOM = 903,
    CREATE_AND_ASSIGN_ROOM = 904,
    ASSIGN_ROOMS = 905,
    CREATE_NEW_ROOM_V2 = 906,
    UPLOAD_OPERATORS = 1001,
    BULK_GENERATE_ORGANIZATIONS_LINKS = 1002,
    USER_GROUP_ADMIN = 1101,
    ACCOUNT_ADMIN_TAB = 1102,
    MANAGE_DATA_ANONYMIZATION = 1103,
    ACCOUNT_USERS_TAB = 1104,
    MANAGE_THIRD_PARTY_REGISTRATION = 1105,
    CONFIGURE_RECURRING_ZOOM_MEETINGS = 1106,
    COMPLAINCE_EMAILS = 1107,
    MANAGE_REGISTRATION_APPROVAL_VIA_API = 1108,
    MANAGE_SEGREGATED_DATA_ENCRYPTION = 1109,
    MANAGE_ORDER_BOOKING = 1110,
    MANAGE_ACCOUNT_SUBDOMAIN = 1111,
    MANAGE_URL_PARAMETER_REGISTRATION = 1112,
    VIEW_EVENT_ATTRIBUTES = 1113,
    MANAGE_EVENT_ATTRIBUTES = 1114,
    MANAGE_AI_AGENT_ACCESS = 1115,
    ASSETS_TAB = 1201,
    UPLOAD_EVENT_ASSETS = 1202,
    DOWNLOAD_EVENT_ASSETS = 1203,
    DELETE_EVENT_ASSETS = 1204,
    GENERATE_EVENT_ASSETS_PUBLIC_DOWNLOAD_LINK = 1205,
    DELETE_ASSET_DOWNLOAD_LINK = 1206,
    ARTIFACTS_TAB = 1301,
    REQUEST_ARTIFACTS = 1302,
    DOWNLOAD_ARTIFACT = 1303,
    DELETE_ARTIFACT = 1304,
    EDIT_ARTIFACT = 1305,
    CREATE_ARTIFACT_PUBLIC_DOWNLOAD_LINK = 1306,
    REQUEST_PASSPORT_REPLAY = 1307,
    CREATE_KNOVIO_LIVE_STREAMS = 1308,
    DELETE_ARTIFACT_DOWNLOAD_LINK = 1309,
    BLUEPRINTS_TAB = 1401,
    CREATE_EVENT_BLUEPRINTS = 1402,
    CREATE_MEETING_TEMPLATES = 1403,
    EDIT_EVENT_BLUEPRINTS = 1404,
    DELETE_EVENT_BLUEPRINTS = 1405,
    CREATE_CONNECTION_TEMPLATES = 1406,
    EDIT_CONNECTION_TEMPLATES = 1407,
    DELETE_CONNECTION_TEMPLATES = 1408,
    EDIT_MEETING_TEMPLATES = 1409,
    DELETE_MEETING_TEMPLATES = 1410,
    CREATE_ORDER_TEMPLATE = 1411,
    EDIT_ORDER_TEMPLATE = 1412,
    EMAIL_TEMPLATES_TAB = 1501,
    CREATE_EMAIL_TEMPLATES = 1502,
    EDIT_EMAIL_TEMPLATES = 1503,
    DELETE_EMAIL_TEMPLATES = 1504,
    MANAGE_PODIUM_ACCESS = 1601,
    EVENT_HUBS_TAB = 1701,
    CREATE_EVENT_HUB = 1702,
    MANAGE_HUB_SUBDOMAIN = 1703,
    EDIT_EVENT_HUB = 1704,
    DELETE_EVENT_HUB = 1705,
    VIEW_HUB_ATTENDEES = 1706,
    CREATE_HUB_ORGANIZATION = 1707,
    CONFIGURE_EVENT_HUB_REGISTRATION_AND_SIGN_IN = 1708,
    CREATE_HUB_ATTENDEES = 1709,
    EDIT_HUB_ATTENDEES = 1710,
    DELETE_HUB_ATTENDEES = 1711,
    HUB_WEBSITE_BUILDER = 1712,
    EDIT_HUB_ORGANIZATION = 1713,
    HUB_MANAGE_PAGES_AND_MODULES = 1714,
    DELETE_HUB_ORGANIZATION = 1715,
    MANAGE_HUB_BRANDING = 1716,
    CREATE_ORDER = 1801,
    UPDATE_ORDER = 1802,
    MANAGE_PRODUCTS = 1803,
    OVERRIDE_BILLING_LOCK = 1804,
    CREATE_ROLODEX_CONTACT = 1901,
    EDIT_ROLODEX_CONTACT = 1902,
    VIEW_OE_DATA_ORGANIZATIONS = 1903,
    MCP_SERVER = 2001,
    MANAGE_AGENT_MEMORY = 2002,
    AI_ASSISTANT = 2003,
}

abstract class IRolesDAO {
    public abstract getRoles(params?: { nextPageToken?: string }): Promise<IRolesListDTO>;
    public abstract getAllRoles(): Promise<IGetRolePermissionsDTO[]>;
    public abstract createRole(roleDetails: ICreateRoleDTO): Promise<void>;
    public abstract getPermissionsByRoleId(roleLinkName: Partial<IRolesDTO>): Promise<IGetRolePermissionsDTO>;
    public abstract updateRolePermissions(params: IPutRolePermissionsDTO): Promise<void>;
    public abstract updateRole(params: IRoleDTO): Promise<void>;
    public abstract deleteRole(roleLinkName: Partial<IRolesDTO>): Promise<void>;
}

enum RolesAction {
    Create = 'Create',
    Edit = 'Edit',
    Delete = 'Delete'
}

interface IRolesListDTO {
    roles: IRolesDTO[];
    nextPageToken: string;
}

interface IRolesDTO extends ICreateRoleDTO {
    linkName: string;
    permissions?: Permission[];
}

interface ICreateRoleDTO {
    name: string;
    description?: string;
}

interface IGetRolePermissionsDTO extends IRoleDTO {
    permissions: Permission[];
}

interface IPutRolePermissionsDTO {
    linkName: string;
    permissions: Permission[];
}

interface IRoleDTO {
    name: string;
    description?: string;
    linkName: string;
}

interface IPermissionsDTO {
    title: string;
    id: Permission;
    status: boolean;
    description: string;
    intlId?: string;
}

export {
    RolesAction,
    IRolesDAO,
    IRolesListDTO,
    IRolesDTO,
    ICreateRoleDTO,
    IPermissionsDTO,
    IGetRolePermissionsDTO,
    IRoleDTO,
    IPutRolePermissionsDTO
};
